"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APSwitcher = void 0;
var IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
var NavigateBefore_1 = __importDefault(require("@material-ui/icons/NavigateBefore"));
var NavigateNext_1 = __importDefault(require("@material-ui/icons/NavigateNext"));
var react_1 = __importStar(require("react"));
var APFlex_1 = require("../layout/APFlex");
var APText_1 = require("../elements/APText");
function APSwitcher(_a) {
    var options = _a.options, onSelect = _a.onSelect, initial = _a.initial, _b = _a.width, width = _b === void 0 ? "150px" : _b;
    var _c = react_1.useState(function () {
        if (initial !== undefined) {
            return options.indexOf(initial);
        }
        return 0;
    }), index = _c[0], setIndex = _c[1];
    react_1.useEffect(function () {
        onSelect(options[index]);
        return function () {
        };
    }, [index]);
    return react_1.default.createElement(APFlex_1.APRow, { mainAxisSize: 'min', crossAxisAlignment: 'center', mainAxisAlignment: 'spaceBetween', style: { width: width, color: "#666" } },
        react_1.default.createElement(IconButton_1.default, { onClick: function () { return setIndex((options.length + index - 1) % options.length); }, size: 'small' },
            react_1.default.createElement(NavigateBefore_1.default, { style: { fontSize: "26px" } })),
        react_1.default.createElement(APText_1.APText, { ellipsis: true, style: { textTransform: 'uppercase', fontWeight: 600, fontSize: "13px" } }, options[index]),
        react_1.default.createElement(IconButton_1.default, { onClick: function () { setIndex((options.length + index + 1) % options.length); }, size: 'small' },
            react_1.default.createElement(NavigateNext_1.default, { style: { fontSize: "26px" } })));
}
exports.APSwitcher = APSwitcher;
